import {
  SentimentDissatisfiedOutlined,
  SentimentNeutralOutlined,
  SentimentSatisfiedOutlined,
  SentimentVeryDissatisfiedOutlined,
  SentimentVerySatisfiedOutlined,
} from "@mui/icons-material";
import React from "react";

export type Emotion = {
  id: "GREAT" | "GOOD" | "NEUTRAL" | "BAD" | "TERRIBLE";
  label: string;
  description: string;
  Icon: React.FC<{ style?: React.CSSProperties }>;
};

export const EMOTIONS: Emotion[] = [
  {
    id: "GREAT",
    label: "Excelente",
    description: "Me siento increíble, con energía y motivado.",
    Icon: ({ style }) => (
      <SentimentVerySatisfiedOutlined
        style={{ width: 48, height: 48, color: "#00c853", ...style }}
      />
    ),
  },
  {
    id: "GOOD",
    label: "Bien",
    description: "Estoy en un buen estado de ánimo, tranquilo y estable",
    Icon: ({ style }) => (
      <SentimentSatisfiedOutlined
        style={{ width: 48, height: 48, color: "#0090fc", ...style }}
      />
    ),
  },
  {
    id: "NEUTRAL",
    label: "Neutral",
    description: "No me siento ni bien ni mal, simplemente en equilibrio.",
    Icon: ({ style }) => (
      <SentimentNeutralOutlined
        style={{ width: 48, height: 48, color: "#00b894", ...style }}
      />
    ),
  },
  {
    id: "BAD",
    label: "Mal",
    description: "Me siento desmotivado, ansioso o frustrado.",
    Icon: ({ style }) => (
      <SentimentDissatisfiedOutlined
        style={{ width: 48, height: 48, color: "#9171fc", ...style }}
      />
    ),
  },
  {
    id: "TERRIBLE",
    label: "Terrible",
    description: "Estoy agotado, triste o abrumado emocionalmente.",
    Icon: ({ style }) => (
      <SentimentVeryDissatisfiedOutlined
        style={{ width: 48, height: 48, color: "#ff9f43", ...style }}
      />
    ),
  },
];

export const getEmotionById = (id: Emotion["id"]) =>
  EMOTIONS.find((e) => e.id === id);
